import React from "react";
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import Grid from '@material-ui/core/Grid';
import FormControl from '@material-ui/core/FormControl';
import TextField from '@material-ui/core/TextField';
import Select from '@material-ui/core/Select';
import MenuItem from '@material-ui/core/MenuItem';
import green from '@material-ui/core/colors/green';
import red from '@material-ui/core/colors/red';
import { Paper } from "@material-ui/core";
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Checkbox from '@material-ui/core/Checkbox';
import Radio from '@material-ui/core/Radio';
import RadioGroup from '@material-ui/core/RadioGroup';

const styles = theme => ({
    root: {
        flexGrow: 1,
        overflow: 'hidden',
    },
    paper: {
        padding: theme.spacing.unit,
        margin: theme.spacing.unit,
    },
    card: {
        minWidth: 275,
    },
    bullet: {
        display: 'inline-block',
        margin: '0 2px',
        transform: 'scale(0.8)',
    },
    title: {
        fontSize: 18,
        fontWeight: 'bold',
    },
    pos: {
        marginBottom: 12,
    },
    group: {
        margin: `${theme.spacing.unit}px 0`,
    },
    formControl: {
        margin: theme.spacing.unit,
    },
    formLabel: {
        textAlign: 'left',
    },
    formInput: {
        padding: 0,
    },
    greenradio: {
        color: green[600],
        '&$checked': {
            color: green[500],
        },
    },
    redradio: {
        color: red[600],
        '&$checked': {
            color: red[500],
        },
    },
    checked: {},
    divider: {
        margin: 16,
    }
});

class ClaimENStep5 extends React.Component {
    state = {
        fp17data: this.props.fp17data,
        pdata: this.props.pdata,
    };

    componentDidMount() {
        //console.log(this.state.fp17data);
    }

    handleChange = name => event => {
        //console.log(name);
        //console.log(event.target.value);

        //this.setState({ [name]: event.target.value });
        let datatmp = this.state.fp17data;
        datatmp[name] = event.target.value;
        this.setState({ fp17data: datatmp });
    };

    handleCheckChange = name => event => {
        //this.setState({ [name]: event.target.value });
        let value = undefined;

        if (event.target.checked === true)
            value = event.target.value;
        else
            value = undefined;

        let datatmp = this.state.fp17data;
        datatmp[name] = value;
        this.setState({ fp17data: datatmp });
    };

    renderStaffOptions() {
        if (this.state.pdata)
        {
            return this.state.pdata.dcp_staff.map((dt, i) => {
                return (
                    <MenuItem
                    key={i}
                    value={dt.gdcno}>
                    {dt.displayname}
                    </MenuItem>
                );
            });
        }
        else
        {
            return;
        }
    }      

    render() {
        const { classes } = this.props;

        return (
            <div className={classes.root}>
                {parseInt(this.state.fp17data.claim_band) !== 13 ?
                    <>
                        <Paper className={classes.paper}>
                            <Typography className={classes.title} color="textSecondary" gutterBottom>
                                Part 7 NICE Guidance
                            </Typography>
                            <Grid container spacing={1}>
                                <Grid item xs={12}>
                                    <span>I have given preventative advice and recommended a recall interval,
                                        taking into account NICE guidance, that I regard as appropriate to the patient's current oral health. (mandatory on over 18yr claims starting 1st October 2022)</span>
                                </Grid>
                                <Grid item xs={3}>
                                    <TextField
                                        id="claim_nice"
                                        value={this.state.fp17data.nice}
                                        type="number"
                                        label="No. of months"
                                        inputProps={{ min: "0", max: "24", step: "1" }}
                                        className={classes.textField}
                                        InputLabelProps={{
                                            shrink: true,
                                        }}
                                        margin="normal"
                                        fullWidth="true"
                                        onChange={this.handleChange('nice')}
                                    />
                                </Grid>

                                <Grid item xs={12}>
                                    <span>Highest BPE Sextant Score (mandatory on over 18yr claims starting 1st October 2022)</span>
                                </Grid>
                                <Grid item xs={3}>
                                <FormControl className={classes.formControl} fullWidth={true}>
                                    <Select
                                        value={this.state.fp17data.cds9378}
                                        onChange={this.handleChange('cds9378')}
                                        inputProps={{
                                            name: 'cds9378',
                                            id: 'claim-cds9378',
                                        }}
                                    >
                                        <MenuItem value="0">0</MenuItem>
                                        <MenuItem value="1">1</MenuItem>
                                        <MenuItem value="2">2</MenuItem>
                                        <MenuItem value="3">3</MenuItem>
                                        <MenuItem value="4">4</MenuItem>
                                        <MenuItem value="0">-</MenuItem>
                                    </Select>
                                </FormControl>
                                </Grid>
                            </Grid>
                        </Paper>
                        <Paper className={classes.paper}>
                            <Typography className={classes.title} color="textSecondary" gutterBottom>
                                Ethnic Origin
                            </Typography>
                            <Grid container spacing={1}>
                                <FormControl className={classes.formControl} fullWidth={true}>
                                    <Select
                                        value={this.state.fp17data.ethorg}
                                        onChange={this.handleChange('ethorg')}
                                        inputProps={{
                                            name: 'ethorg',
                                            id: 'claim-ethorg',
                                        }}
                                    >
                                        <MenuItem value="99">Patient Declined</MenuItem>
                                        <MenuItem value="01">White British</MenuItem>
                                        <MenuItem value="02">White Irish</MenuItem>
                                        <MenuItem value="03">White Other</MenuItem>
                                        <MenuItem value="04">White and Black Caribbean</MenuItem>
                                        <MenuItem value="05">White and Black African</MenuItem>
                                        <MenuItem value="06">White and Asian</MenuItem>
                                        <MenuItem value="07">Other Mixed Background</MenuItem>
                                        <MenuItem value="08">Asian or Asian British Indian</MenuItem>
                                        <MenuItem value="09">Asian or Asian British Pakistani</MenuItem>
                                        <MenuItem value="10">Asian or Asian British Bangladeshi</MenuItem>
                                        <MenuItem value="11">Other Asian Bbackground</MenuItem>
                                        <MenuItem value="12">Black or Black British Caribbean</MenuItem>
                                        <MenuItem value="13">Black or Black British African</MenuItem>
                                        <MenuItem value="14">Other Black Background</MenuItem>
                                        <MenuItem value="15">Chinese</MenuItem>
                                        <MenuItem value="16">Any Other Ethnic Group</MenuItem>
                                    </Select>
                                </FormControl>
                            </Grid>
                        </Paper>
                        <Paper className={classes.paper}>
                            <Typography className={classes.title} color="textSecondary" gutterBottom>
                                Contact Consent
                            </Typography>
                            <Grid container spacing={3}>
                                {this.state.pdata.hasemail === true ?
                                    <Grid item xs={12} sm={4}>
                                        <FormControl className={classes.formControl} fullWidth={true}>
                                            <FormControlLabel
                                                value="y"
                                                id="nhs_emailconsent"
                                                label="Send Email address"
                                                control={<Checkbox checked={this.state.fp17data.nhs_emailconsent === 'y'} />}
                                                onChange={this.handleCheckChange('nhs_emailconsent')}
                                            />
                                        </FormControl>
                                    </Grid> : null}
                                {this.state.pdata.hasmobile === true ?
                                    <Grid item xs={12} sm={4}>
                                        <FormControl className={classes.formControl} fullWidth={true}>
                                            <FormControlLabel
                                                value="y"
                                                id="nhs_mobileconsent"
                                                label="Send mobile number"
                                                control={<Checkbox checked={this.state.fp17data.nhs_mobileconsent === 'y'} />}
                                                onChange={this.handleCheckChange('nhs_mobileconsent')}
                                            />
                                        </FormControl>
                                    </Grid> : null}
                            </Grid>
                        </Paper>
                    </>
                    :
                    <>
                        <Paper className={classes.paper}>
                            <span>Recall period and ethic origin are not required on Band 6 claims.</span>
                        </Paper>
                    </>}
                    {this.state.fp17data.datacc > '2022-10-01' ?
                <Paper className={classes.paper}>
                    <Grid container spacing={1}>
                        <Grid item xs={12} sm={6}>
                            <Typography className={classes.title} color="textSecondary" gutterBottom>
                                DCP involved
                            </Typography>
                            <FormControl className={classes.formControl} fullWidth={true}>
                                <Select
                                    value={this.state.fp17data.dcp_staff}
                                    onChange={this.handleChange('dcp_staff')}
                                    inputProps={{
                                        name: 'dcp_staff',
                                        id: 'dcp_staff',
                                    }}
                                >
                                    <MenuItem/>
                                    {this.renderStaffOptions()}
                                </Select>
                            </FormControl>
                        </Grid>
                        <Grid item xs={12} sm={6}>
                            <Typography className={classes.title} color="textSecondary" gutterBottom>
                                capacity
                            </Typography>
                            <FormControl className={classes.formControl} fullWidth={true}>
                                <Select
                                    value={this.state.fp17data.dcp_capacity}
                                    onChange={this.handleChange('dcp_capacity')}
                                    inputProps={{
                                        name: 'dcp_capacity',
                                        id: 'dcp_capacity',
                                    }}
                                >
                                    <MenuItem value="01">Therapist</MenuItem>
                                    <MenuItem value="02">Hygienist</MenuItem>
                                    <MenuItem value="03">Dental Nurse</MenuItem>
                                    <MenuItem value="04">Technician</MenuItem>
                                </Select>
                            </FormControl>
                        </Grid>
                    </Grid>
                </Paper>
                : null }
                {this.state.fp17data.batch_id ?
                    <Paper className={classes.paper}>
                        <Typography className={classes.title} color="textSecondary" gutterBottom>
                            Schedule Query
                        </Typography>
                        <Typography color="textSecondary" gutterBottom>
                            This claim has been sent previously, how would you like the board to deal with it?
                        </Typography>
                        <FormControl component="fieldset" className={classes.formControl}>
                            <RadioGroup
                                aria-label="sqind"
                                name="sqind"
                                className={classes.group}
                                value={this.state.fp17data.sqind}
                                onChange={this.handleChange('sqind')}
                                row
                            >
                                <FormControlLabel value="1" control={<Radio />} label="Replacement" />
                                <FormControlLabel value="3" control={<Radio />} label="Deletion" />
                                <FormControlLabel value="-1" control={<Radio />} label="Error Correction" />
                            </RadioGroup>
                        </FormControl>
                    </Paper>
                    : null}
            </div>
        );
    }
}

ClaimENStep5.propTypes = {
    classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(ClaimENStep5);